<template>
  <div class="sy-nav">
    <van-nav-bar
      :title="$t('routerBase.'+$route.meta.title)"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <van-cell-group class="vancellgroup">
      <van-field
        readonly
        clickable
        :label="$t('viewBase.relationship')"
        class="align"
        input-align="right"
        :value="info.relationShip"
        is-link
        :placeholder="$t('viewBase.promptrelationship')"
        @click="showPicker = true"
      />
      <van-field v-model="info.phone" type="tel" input-align="right" :label="$t('viewBase.mobilenumber')" :placeholder="$t('viewBase.promptmobile')" />
    </van-cell-group>
    <van-popup v-model="showPicker" position="bottom" :overlay="true">
      <van-picker
        :visible-item-count="3"
        class="van-picker_relative"
        show-toolbar
        :columns="relationshipList"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div class="bindPhone" @click="bindPhone">{{ $t('viewBase.bindnow') }}</div>
  </div>
</template>

<script>
import { getFamilyRelationshipList, bindGroupFamily } from '@/api/family'
import debounce from 'lodash.debounce'
import { isMobile } from '@/utils/tool'
import { getUserGroupId } from '@/utils/auth'
import { Toast } from 'vant'
export default {
  data() {
    return {
      value: '',
      showPicker: false,
      relationshipList: [],
      columnsGender: [this.$t('viewBase.male'), this.$t('viewBase.female')],
      info: {
        phone: '',
        userGroupId: getUserGroupId(),
        relationShip: ''
      }
    }
  },
  created() {
    getFamilyRelationshipList().then(response => {
      response.data.data.forEach(item => {
        item.text = item.relationship
      })
      this.relationshipList = response.data.data
    })
  },
  methods: {
    onConfirm(value) {
      this.info.relationShip = value.relationship
      this.showPicker = false
    },
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
      //   Toast('返回')
    },
    bindPhone: debounce(async function() {
      console.log(getUserGroupId())
      const { phone } = this.info
      if (!this.info.relationShip) {
        return Toast({
          message: '家人关系未选择',
          duration: 1500
        })
      }
      if (!isMobile(phone)) {
        return Toast({
          message: '手机号格式错误',
          duration: 1500
        })
      }
      try {
        const { data } = await bindGroupFamily(this.info)
        console.log(data)
        if (data) {
          this.$toast('绑定成功')
          setTimeout(_ => {
            this.$router.go(-1)
          }, 1500)
        }
      } catch (error) {
        console.log('[login error]:', error)
      }
    }, 300, { leading: true })
  }
}
</script>

<style scoped lang="scss">
  .van-field__control {
    text-align: right;
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 2px;
    vertical-align: middle;
  }

  .align {
    align-items: center;
    padding-right: 11px;
  }

  .file {
    position: absolute;
    right: -20px;
    width: 80px;
    height: 40px;
    opacity: 0;
    z-index: 100;
  }

  .btn {
    width: 92%;
    margin: 30px 4% 0;
    background: #F99600;
    color: #fff;
  }

  .btn-logout {
    background: #bbb;
    margin: 20px 4%;
  }

  .bindPhone{
    width:94%;
    height:44px;
    background:linear-gradient(90deg,rgba(248,142,0,1) 0%,rgba(252,193,0,1) 100%);
    border-radius:4px;
    margin:156px auto;
    font-size:17px;
    font-family:PingFangSC-Regular;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:44px;
    text-align: center;
  }
  /deep/.van-nav-bar .van-icon {
    color: #F18937;
    vertical-align: middle;
  }
</style>

